import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './stores/store.js';
import axios from 'axios';

import PrimeVue from 'primevue/config';

import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import ColorPicker from 'primevue/colorpicker';
import Column from 'primevue/column';
import ConfirmDialog from 'primevue/confirmdialog';
import DataTable from 'primevue/datatable';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import FileUpload from 'primevue/fileupload';
import Inplace from 'primevue/inplace';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import InputSwitch from 'primevue/inputswitch';
import Menu from 'primevue/menu';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import ProgressBar from 'primevue/progressbar';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import Sidebar from 'primevue/sidebar';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tree from 'primevue/tree';
import Chips from 'primevue/chips';


import { auth } from '@/firebase';
import VueFirestore from 'vue-firestore'
import { VueMaskDirective } from 'v-mask'

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import './assets/layout/layout.scss';

//import Rollbar from 'rollbar';

// Set the Rollbar instance in the Vue prototype
// before creating the first Vue instance.
// This ensures it is available in the same way for every
// instance in your app.
// Vue.prototype.$rollbar = new Rollbar({
// 	accessToken: '0bd02dd7492a4a688bf549e15ebd13ee',
//     captureUncaught: true,
//     captureUnhandledRejections: true,
//     payload: {
//         environment: 'production',
//         // context: 'rollbar/test'
//         client: {
//           javascript: {
//             code_version: '1.0',
//             // source_map_enabled: true,
//             // guess_uncaught_frames: true
//           }
//         }
//     }
// });

// If you have already set up a global error handler,
// just add `vm.$rollbar.error(err)` to the top of it.
// If not, this simple example will preserve the app’s existing
// behavior while also reporting uncaught errors to Rollbar.
Vue.config.errorHandler = (err, vm, info) => {
    vm.$rollbar.error(err);
    throw err; // rethrow
};

// Add an interceptor for handling 401 errors
axios.interceptors.response.use(
    function (response) {
        // Any status code that is within the range of 2xx will trigger this function
        return response;
    },
    function (error) {
        // Check if the error response status is 401
        if (error.response && error.response.status === 401) {
            // Redirect to login or error page
            // console.log('401 ERROR')
            router.push('/signout'); // Adjust the route as needed
        }
        return Promise.reject(error); // Pass the error along if not 401
    }
);

Vue.directive('mask', VueMaskDirective);

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

Vue.use(VueFirestore, {
    key: 'key'
});
Vue.use(ToastService);
Vue.use(PrimeVue, { ripple: true });
Vue.directive('ripple', Ripple);

Vue.prototype.$appState = Vue.observable({ inputStyle: 'outlined' });

Vue.config.productionTip = false;
import './registerServiceWorker'

import ConfirmationService from 'primevue/confirmationservice';
Vue.use(ConfirmationService);

Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('Button', Button);
Vue.component('Calendar', Calendar);
Vue.component('Card', Card);
Vue.component('Checkbox', Checkbox);
Vue.component('ColorPicker', ColorPicker);
Vue.component('Column', Column);
Vue.component('ConfirmDialog', ConfirmDialog);
Vue.component('DataTable', DataTable);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('FileUpload', FileUpload);
Vue.component('Inplace', Inplace);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber);
Vue.component('InputMask', InputMask);
Vue.component('InputSwitch', InputSwitch);
Vue.component('Menu', Menu);
Vue.component('Message', Message);
Vue.component('MultiSelect', MultiSelect);
Vue.component('Paginator', Paginator);
Vue.component('Panel', Panel);
Vue.component('PanelMenu', PanelMenu);
Vue.component('Password', Password);
Vue.component('ProgressBar', ProgressBar);
Vue.component('RadioButton', RadioButton);
Vue.component('SelectButton', SelectButton);
Vue.component('Sidebar', Sidebar);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('Toast', Toast);
Vue.component('Tree', Tree);
Vue.component('Chips', Chips);

new Vue({
    router,
    store,
    render: h => h(App),
    created() {
        window.addEventListener('offline', () => {
            store.dispatch('setConnected', false)
            console.log("offline");
        })
        window.addEventListener('online', () => {
            store.dispatch('setConnected', true)
            console.log("online");
        })
    }
}).$mount('#app');
